import service from "@irati/utils/tracking";
var PerksGOTrackingEvents = /** @class */ (function () {
    function PerksGOTrackingEvents() {
    }
    PerksGOTrackingEvents.prototype.showFindOutMoreModal = function (modalLocation) {
        var data = {
            modal_location: modalLocation
        };
        service.trackPerksEvent("perksgo_find_out_more", data);
    };
    PerksGOTrackingEvents.prototype.showLinkCardModal = function (modalLocation) {
        var data = {
            modal_location: modalLocation
        };
        service.trackPerksEvent("perksgo_add_card_details", data);
    };
    PerksGOTrackingEvents.prototype.cardSuccessfullyLinked = function (cardCount) {
        var data = {
            card_number: cardCount
        };
        service.trackPerksEvent("perksgo_link_card", data);
    };
    PerksGOTrackingEvents.prototype.goToWalletCTA = function () {
        service.trackPerksEvent("perksgo_go_wallet_cta");
    };
    PerksGOTrackingEvents.prototype.manageLinkedCardsCTA = function () {
        service.trackPerksEvent("perksgo_manage_linked_cards_cta");
    };
    PerksGOTrackingEvents.prototype.clickMyLinkedCards = function () {
        service.trackPerksEvent("perksgo_click_my_linked_cards");
    };
    PerksGOTrackingEvents.prototype.clickLinkNewCard = function () {
        service.trackPerksEvent("perksgo_click_link_new_card");
    };
    PerksGOTrackingEvents.prototype.clickDeleteLinkedCard = function () {
        service.trackPerksEvent("perksgo_click_delete_linked_card");
    };
    PerksGOTrackingEvents.prototype.confirmDeleteLinkedCard = function (cardCount) {
        var data = {
            card_number: cardCount
        };
        service.trackPerksEvent("perksgo_confirm_delete_linked_card", data);
    };
    PerksGOTrackingEvents.prototype.cancelDeleteLinkedCard = function () {
        service.trackPerksEvent("perksgo_cancel_delete_linked_card");
    };
    return PerksGOTrackingEvents;
}());
export default new PerksGOTrackingEvents();
